import React, { useState } from "react";
import Loader from "react-loader-spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import PhoneInput from "react-phone-input-2";
import { useTranslation } from "react-i18next";
import { onMessageListener } from "../../utils/pushNotification";

import { toastMessage } from "../../utils/toast";
import * as userActions from "../../Redux/Actions/user";
import { getLocaleValue } from "../../utils";

const Register = ({ history }) => {
  const { t, i18n } = useTranslation();
  const [errMsg, setErrMsg] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [firstNameEMsg, setFirstNameEMsg] = useState("");
  const [lastNameEMsg, setLastNameEMsg] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [buttonLoading, setButtonLoading] = useState("");
  const [titleId, setTitleId] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [condition, setCondition] = useState(false);
  const [passwordShown, setPassWordShown] = useState(false);
  const [confirmPassWordShown, setConfirmPassWordShown] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem("i18nextLng")
  );

  const eye = <FontAwesomeIcon icon={faEye} />;
  const eyeSlash = <FontAwesomeIcon icon={faEyeSlash} />;

  const changeLanguage = (value) => {
    i18n.changeLanguage(value);
    setCurrentLanguage(value);
  };
  const handleOk = () => {
    setButtonLoading(true);
    if (
      firstName !== "" &&
      lastName !== "" &&
      email !== "" &&
      password !== "" &&
      mobileNumber !== "" &&
      countryCode !== "" &&
      titleId !== "" &&
      condition !== false
    ) {
      if (password !== confirmPassword) {
        setButtonLoading(false);
        toastMessage("error", `Enter the same password in confirm password`);
      } else if (mobileNumber.length < 8) {
        setErrMsg("Phone Number must be of atleast 8 digit");
        setButtonLoading(false);
      } else if (password.length < 8) {
        setErrMsg("Password must be of atleast 8 digit");
        setButtonLoading(false);
      } else if (firstNameEMsg != "" || lastNameEMsg != "") {
        setButtonLoading(false);
      } else {
        let lowerEmail = email.toLowerCase();
        const payload = {
          title: titleId,
          firstName,
          lastName,
          email: lowerEmail,
          mobileNumber,
          countryCode: `+${countryCode}`,
          password,
        };

        userActions
          .userRegister(payload)
          .then((res) => {
            if (res && (res.status === 200 || res.status === 204)) {
              toastMessage("success", "User Registered Successfully");
              setButtonLoading(false);
              history.push("/login");
            } else if (res && res.status === 400) {
              setButtonLoading(false);
              toastMessage("error", "Alredy exist");
              history.push(`/register`);
            } else {
              toastMessage("error", "User Registered Failed");
              setButtonLoading(false);
            }
          })
          .catch((err) => {
            setButtonLoading(false);
            toastMessage("error", err?.response?.data.data.validations[0]);
            setButtonLoading(false);
          });
      }
    } else {
      setErrMsg(getLocaleValue("Please fill all required field"));
      setButtonLoading(false);
    }
  };

  const handleOnChange = (value, data) => {
    setCountryCode(data.dialCode);
    let val = value.slice(data.dialCode.length);
    setMobileNumber(val);
    val.length < 8 && val.length > 0
      ? setErrMsg("Phone Number must be of atleast 8 digit")
      : setErrMsg("");
  };

  const handlePasswordChange = (e) => {
    setErrMsg("");
    setPassword(e.target.value);
    e.target.value.length < 8 && e.target.value.length > 0
      ? setErrMsg("Password  must be of atleast 8 digit")
      : setErrMsg("");
  };

  const togglePassword = () => {
    setPassWordShown(!passwordShown);
  };

  const toggleConfirmPassword = () => {
    setConfirmPassWordShown(!confirmPassWordShown);
  };

  onMessageListener().then(payload => {
    console.log(payload);
}).catch(err => console.log('failed: ', err));

  return (
    <div className="account-body d-flex flex-column justify-content-center vw-100">
      <div
        className="logo logo-admin position-absolute"
        style={{ left: "60px", top: 0 }}
      >
        <img
          src="/Assets/aamer_logo.jpg"
          width="150px"
          height="auto"
          alt="logo"
          className="auth-logo"
        />
      </div>
      <div className="position-absolute" style={{ right: "10px", top: -40 }}>
        <div style={{ marginTop: "60px", marginRight: "60px" }}>
          <span
            style={{
              fontSize: "20px",
              color: "#b71c1c",
              cursor: "pointer",
              borderBottom: currentLanguage == "english" ? "2px solid" : "0px",
              fontWeight: "bold",
            }}
            onClick={() => {
              changeLanguage("english");
            }}
          >
            EN
          </span>
          <span
            style={{
              marginLeft: "10px",
              marginRight: "10px",
              fontSize: "20px",
              color: "#b71c1c",
              fontWeight: "bold",
            }}
          >
            |
          </span>
          <span
            style={{
              fontSize: "20px",
              color: "#b71c1c",
              cursor: "pointer",
              borderBottom: currentLanguage == "arabic" ? "2px solid" : "0px",
              fontWeight: "bold",
            }}
            onClick={() => {
              changeLanguage("arabic");
            }}
          >
            AR
          </span>
        </div>
      </div>
      <div className="container">
        <div className="row d-flex justify-content-center">
          <div className="col-12 align-self-center">
            <div className="row">
              <div className="col-lg-5 mx-auto" style={{ marginTop: "300px" }}>
                <div className="card">
                  <div className="card-body p-0 auth-header-box">
                    <div className="text-center p-3">
                      <h4 className="mt-3 mb-1 fw-semibold text-white font-30">
                        Aamer Customer App
                      </h4>
                      {/* <p className="mb-0" style={{color: '#b71c1c'}}>Sign in to continue to Aamer Customer App</p>   */}
                    </div>
                  </div>
                  <div className="card-body p-0">
                    <ul className="nav-border nav nav-pills">
                      <li className="nav-item">
                        <p
                          className="nav-link active fw-semibold m-0 c-pointer ms-2 font-20"
                          style={{ lineHeight: "33px" }}
                        >
                          {getLocaleValue("login_enroll")}
                        </p>
                      </li>
                    </ul>
                    <div className="tab-content">
                      <div className="tab-pane active p-3" role="tabpanel">
                        <div className="form-horizontal auth-form">
                          <div className="form-group mb-2">
                            <label
                              className="form-label font-18"
                              htmlFor="title"
                            >
                              {getLocaleValue("signup_title")}
                            </label>
                            <div className="input-group">
                              <select
                                className="form-select"
                                value={titleId}
                                onChange={(e) => {
                                  setTitleId(e.target.value);
                                  setErrMsg("");
                                }}
                                style={{ width: "53%", height: "35px" }}
                              >
                                <option
                                  className="font-17"
                                  value=""
                                  disabled={true}
                                >
                                  {getLocaleValue("select_title")}
                                </option>
                                <option className="font-17" value="Mr.">
                                  Mr.
                                </option>
                                <option className="font-17" value="Mrs.">
                                  Mrs.
                                </option>
                                <option className="font-17" value="Major.">
                                  Major
                                </option>
                                <option className="font-17" value="Dr.">
                                  Dr.
                                </option>
                              </select>
                            </div>
                          </div>

                          <div className="form-group mb-2">
                            <label
                              className="form-label font-18"
                              htmlFor="firstname"
                            >
                              {getLocaleValue("signup_first_name")}
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="firstname"
                                placeholder="Enter firstname"
                                value={firstName}
                                onChange={(e) => {
                                  setErrMsg("");
                                  const re = /^[a-zA-Z0-9_ ]*$/;
                                  if (
                                    e.target.value === "" ||
                                    re.test(e.target.value)
                                  ) {
                                    setFirstName(e.target.value);
                                  }
                                  setErrMsg("");
                                  e.target.value.length > 25
                                    ? setFirstNameEMsg(
                                        "First name should be maximum 25"
                                      )
                                    : setFirstNameEMsg("");
                                }}
                              />
                            </div>
                          </div>
                          {firstNameEMsg && (
                            <p className="text-danger mt-2 text-center font-weight-bold font-18">
                              {firstNameEMsg}
                            </p>
                          )}
                          <div className="form-group mb-2">
                            <label
                              className="form-label font-18"
                              htmlFor="lastname"
                            >
                              {getLocaleValue("signup_last_name")}
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="lastname"
                                placeholder="Enter lastname"
                                value={lastName}
                                onChange={(e) => {
                                  setErrMsg("");
                                  const re = /^[a-zA-Z0-9_ ]*$/;
                                  if (
                                    e.target.value === "" ||
                                    re.test(e.target.value)
                                  ) {
                                    setLastName(e.target.value);
                                  }
                                  setErrMsg("");
                                  e.target.value.length > 25
                                    ? setLastNameEMsg(
                                        "Last name should be maximum 25"
                                      )
                                    : setLastNameEMsg("");
                                }}
                              />
                            </div>
                          </div>
                          {lastNameEMsg && (
                            <p className="text-danger mt-2 text-center font-weight-bold font-18">
                              {lastNameEMsg}
                            </p>
                          )}
                          <div className="form-group mb-2">
                            <label
                              className="form-label font-18"
                              htmlFor="email"
                            >
                              {getLocaleValue("signup_email")}
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="email"
                                placeholder="Enter email"
                                value={email}
                                onChange={(e) => {
                                  setEmail(e.target.value);
                                  setErrMsg("");
                                }}
                              />
                            </div>
                          </div>
                          <div className="form-group mb-2 ">
                            <label className="form-label font-18">
                              {getLocaleValue("usr_profile_phone_number")}
                            </label>
                            <div>
                              <PhoneInput
                                country={"ae"}
                                countryCodeEditable={false}
                                placeholder={"Enter Mobile Number"}
                                onChange={handleOnChange}
                                required={true}
                                className="col-sm-2 col-md-6"
                              />
                            </div>
                          </div>
                          <div className="form-group mb-2">
                            <label
                              className="form-label font-18"
                              htmlFor="userpassword"
                            >
                              {getLocaleValue("signup_password")}
                            </label>
                            <div className="input-group">
                              <input
                                type={passwordShown ? "text" : "password"}
                                className="form-control"
                                name="password"
                                placeholder="Enter password"
                                value={password}
                                onChange={handlePasswordChange}
                              ></input>
                              <div className="input-group-btn">
                                <button
                                  className="btn btn-outline-primary"
                                  onClick={togglePassword}
                                >
                                  {passwordShown ? (
                                    <i>{eye}</i>
                                  ) : (
                                    <i>{eyeSlash}</i>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="form-group mb-2">
                            <label
                              className="form-label font-18"
                              htmlFor="userpassword"
                            >
                              {getLocaleValue("signup_confirm_password")}
                            </label>
                            <div className="input-group">
                              <input
                                type={
                                  confirmPassWordShown ? "text" : "password"
                                }
                                className="form-control"
                                name="confirmPassword"
                                placeholder="Enter password"
                                value={confirmPassword}
                                onChange={(e) => {
                                  setErrMsg("");
                                  setConfirmPassword(e.target.value);
                                }}
                              ></input>
                              <div className="input-group-btn">
                                <button
                                  className="btn btn-outline-primary"
                                  onClick={toggleConfirmPassword}
                                >
                                  {confirmPassWordShown ? (
                                    <i>{eye}</i>
                                  ) : (
                                    <i>{eyeSlash}</i>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="form-group mb-4 d-flex mt-4">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              required={true}
                              checked={condition}
                              value=""
                              id="defaultCheck1"
                              onClick={(e) => {
                                setErrMsg("");
                                setCondition(e.target.checked);
                              }}
                              style={{ margin: "auto 0" }}
                            />
                            <label class="form-check-label font-18">
                              <a
                                href="https://aamerhub.ae/home/privacy_policy"
                                target={"_blank"}
                                style={{
                                  marginLeft: "10px",
                                  textDecoration: "underline",
                                }}
                              >
                                I have read & accepted terms & conditions{" "}
                              </a>
                            </label>
                          </div>
                          {(errMsg || email === "" || password === "") && (
                            <p className="text-danger mt-2 text-center font-weight-bold font-18">
                              {errMsg}
                            </p>
                          )}
                          <div className="form-group mb-0 row">
                            <div className="col-12">
                              <button
                                className="btn btn-primary w-100 waves-effect waves-light d-flex align-items-center justify-content-center font-18"
                                type="button"
                                disabled={buttonLoading}
                                onClick={() => {
                                  handleOk();
                                }}
                              >
                                {getLocaleValue("login_enroll")}
                                {buttonLoading && (
                                  <Loader
                                    type="Oval"
                                    color="#fff"
                                    height={20}
                                    width={20}
                                    style={{ marginLeft: "10px" }}
                                  />
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body bg-light-alt text-center">
                    <span className="text-muted d-none d-sm-inline-block">
                      Aamer © 2021
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
